import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

const CATEGORIES: Record<string, string> = {
  emergency: 'Яаралтай', management: 'Удирдлага', utility: 'Ашиглалт',
  service: 'Үйлчилгээ', government: 'Засаг захиргаа', other: 'Бусад',
};

const CAT_COLORS: Record<string, string> = {
  emergency: '#ef4444', management: '#236844', utility: '#3b82f6',
  service: '#f59e0b', government: '#8b5cf6', other: '#6b7280',
};

interface ContactForm {
  name: string; phone: string; phone2: string; category: string;
  description: string; is_pinned: boolean; sort_order: number;
}

const emptyForm: ContactForm = {
  name: '', phone: '', phone2: '', category: 'management',
  description: '', is_pinned: false, sort_order: 0,
};

export default function ContactsPage() {
  const [contacts, setContacts] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState<string | null>(null);
  const [form, setForm] = useState<ContactForm>(emptyForm);

  const load = () => {
    setLoading(true);
    const params = filter ? `?category=${filter}` : '';
    api.get(`/admin/contacts${params}`)
      .then(data => { setContacts(data?.items || []); setTotal(data?.total || 0); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, [filter]);

  const handleSubmit = async () => {
    try {
      if (editId) {
        await api.put(`/admin/contacts/${editId}`, form);
      } else {
        await api.post('/admin/contacts', form);
      }
      setShowForm(false);
      setEditId(null);
      setForm(emptyForm);
      load();
    } catch { /* ignore */ }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Устгах уу?')) return;
    try { await api.delete(`/admin/contacts/${id}`); load(); } catch {}
  };

  const openEdit = (c: any) => {
    setEditId(c.id);
    setForm({
      name: c.name, phone: c.phone, phone2: c.phone2 || '', category: c.category,
      description: c.description || '', is_pinned: c.is_pinned, sort_order: c.sort_order || 0,
    });
    setShowForm(true);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 24, color: '#1c2b22', margin: 0 }}>
          Холбоо барих ({total})
        </h2>
        <button onClick={() => { setEditId(null); setForm(emptyForm); setShowForm(true); }} style={btnPrimary}>
          + Шинэ холбоо барих
        </button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('')} style={filterBtn(!filter)}>Бүгд</button>
        {Object.entries(CATEGORIES).map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)} style={{
            ...filterBtn(filter === key),
            background: filter === key ? CAT_COLORS[key] : '#e8e5dc',
          }}>{label}</button>
        ))}
      </div>

      {loading ? <p style={{ color: '#5f6f66' }}>Уншиж байна...</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
          {contacts.map(c => (
            <div key={c.id} style={{
              background: '#fff', borderRadius: 12, padding: 20,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              borderLeft: `4px solid ${CAT_COLORS[c.category] || '#6b7280'}`,
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    {c.is_pinned && <span title="Бэхлэгдсэн">📌</span>}
                    <strong style={{ fontSize: 16, color: '#1c2b22' }}>{c.name}</strong>
                  </div>
                  <span style={{
                    fontSize: 11, padding: '2px 8px', borderRadius: 12,
                    background: `${CAT_COLORS[c.category] || '#6b7280'}15`,
                    color: CAT_COLORS[c.category] || '#6b7280', fontWeight: 600,
                  }}>
                    {CATEGORIES[c.category] || c.category}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => openEdit(c)} style={smallBtn}>Засах</button>
                  <button onClick={() => handleDelete(c.id)} style={{ ...smallBtn, color: '#ef4444', background: '#fef2f2' }}>Устгах</button>
                </div>
              </div>
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 18, fontWeight: 600, color: '#236844', marginBottom: 4 }}>
                  {c.phone}
                </div>
                {c.phone2 && <div style={{ fontSize: 14, color: '#5f6f66' }}>{c.phone2}</div>}
                {c.description && <div style={{ fontSize: 13, color: '#5f6f66', marginTop: 8 }}>{c.description}</div>}
              </div>
            </div>
          ))}
          {contacts.length === 0 && (
            <div style={{ gridColumn: '1/-1', textAlign: 'center', padding: 40, color: '#94a3b8' }}>
              Холбоо барих мэдээлэл олдсонгүй
            </div>
          )}
        </div>
      )}

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowForm(false)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 480, maxHeight: '80vh', overflow: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 20, color: '#1c2b22', marginTop: 0 }}>
              {editId ? 'Засах' : 'Шинэ холбоо барих'}
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={labelStyle}>Нэр</label>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={inputStyle} placeholder="Байгууллага/хүний нэр" />
              </div>
              <div>
                <label style={labelStyle}>Ангилал</label>
                <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} style={inputStyle}>
                  {Object.entries(CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div>
                  <label style={labelStyle}>Утас</label>
                  <input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} style={inputStyle} placeholder="102" />
                </div>
                <div>
                  <label style={labelStyle}>Нэмэлт утас</label>
                  <input value={form.phone2} onChange={e => setForm({ ...form, phone2: e.target.value })} style={inputStyle} placeholder="7700-0000" />
                </div>
              </div>
              <div>
                <label style={labelStyle}>Тайлбар</label>
                <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} rows={3} style={{ ...inputStyle, resize: 'vertical' }} placeholder="Нэмэлт мэдээлэл" />
              </div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                <input type="checkbox" checked={form.is_pinned} onChange={e => setForm({ ...form, is_pinned: e.target.checked })} />
                Бэхлэх (дээд талд харагдана)
              </label>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowForm(false)} style={{ padding: '10px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>Цуцлах</button>
                <button onClick={handleSubmit} disabled={!form.name.trim() || !form.phone.trim()} style={{ ...btnPrimary, opacity: form.name.trim() && form.phone.trim() ? 1 : 0.5 }}>
                  {editId ? 'Хадгалах' : 'Нэмэх'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function filterBtn(active: boolean): React.CSSProperties {
  return {
    padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
    background: active ? '#236844' : '#e8e5dc', color: active ? '#fff' : '#5f6f66', fontWeight: active ? 600 : 400,
  };
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none',
  padding: '10px 20px', borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const smallBtn: React.CSSProperties = {
  background: '#f0f9f4', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', color: '#236844', fontSize: 12,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#374151', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box',
};
